// The catalogue's browser entry (UC-30, UC-31). Every page arrives rendered
// by the catalogue's worker; this brings the design system and mounts the
// parts that act: the menu's button, the shop list, the shop's address, the
// menu filter, the list or cards switch and the item sheet.
import '../design.css';
import '../base.css';
import { startIslands } from './islands';
import ItemSheet from './ItemSheet.svelte';
import LayoutSwitch from './LayoutSwitch.svelte';
import MenuFilter from './MenuFilter.svelte';
import NavMenu from './NavMenu.svelte';
import ShopAddress from './ShopAddress.svelte';
import ShopPicker from './ShopPicker.svelte';

startIslands({
	nav: NavMenu,
	shops: ShopPicker,
	address: ShopAddress,
	filter: MenuFilter,
	view: LayoutSwitch,
	item: ItemSheet,
});
